import { Theme } from '@mui/material/styles'

const muiButton = (theme: Theme) => {
  return {
    variants: [
      {
        props: { variant: 'text' },
        style: {
          // padding: 0,
          // background: theme.palette.text.primary,
          '&:hover': {
            background: theme.palette.primary.light
          },
          '&:disabled': {
            '& svg': {
              color: 'rgba(0, 0, 0, 0.26)'
            },
            '&:hover': {
              backgroundColor: 'transparent'
            }
          }
        }
      },

      {
        props: { variant: 'text', color: 'secondary' },
        style: {
          color: theme.palette.text.secondary,
          // height: 'auto',
          '&:hover': {
            background: theme.palette.primary.light
          },
          '&:disabled': {
            '& svg': {
              color: 'rgba(0, 0, 0, 0.26)'
            },
            '&:hover': {
              backgroundColor: 'transparent'
            }
          }
        }
      },
      {
        props: { size: 'smallest' },
        style: {
          fontSize: '0.75rem',
          fontWeight: 400,
          borderRadius: 7,
          height: '1.75rem',
          '& svg': {
            height: '0.875rem',
            width: '0.875rem'
          }
        }
      }
    ],
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
      disableFocusRipple: false
    },
    styleOverrides: {
      root: {
        boxShadow: 'none',
        paddingLeft: 16,
        paddingRight: 16,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        minWidth: 'auto',
        '&.Mui-focused': {
          border: '1px solid #090909'
        },
        '& .MuiButton-endIcon': {
          marginRight: 0
        },
        '& .MuiButton-startIcon': {
          marginLeft: 0
        }
      },
      sizeLarge: {
        fontSize: '0.875rem',
        fontWeight: 600,
        borderRadius: 10,
        height: '2.625rem',
        '& svg': {
          height: '1.25rem',
          width: '1.25rem'
        }
      },
      sizeMedium: {
        fontSize: '0.875rem',
        borderRadius: 9,
        height: '2.25rem',
        '& svg': {
          height: '1.125rem',
          width: '1.125rem'
        }
      },
      sizeSmall: {
        fontSize: '0.75rem',
        borderRadius: 8,
        height: '2rem',
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem',
        '& svg': {
          height: '1rem',
          width: '1rem'
        }
      }
    }
  }
}

export default muiButton
